import React, { useEffect, useState } from "react";
import { Edit } from "lucide-react";
import { api, fmtDate } from "@/lib/api";
import { LeaveRecordDialog } from "@/components/LeaveRecordDialog";

const TONE = { ucretli_izin: "bg-emerald-100 text-emerald-800", ucretsiz_izin: "bg-amber-100 text-amber-800", raporlu: "bg-rose-100 text-rose-800" };
const GUN = ["Pazar", "Pazartesi", "Salı", "Çarşamba", "Perşembe", "Cuma", "Cumartesi"];
const n1 = (v) => Number(v || 0).toLocaleString("tr-TR", { maximumFractionDigits: 1 });

const ManualNote = ({ row, items }) => {
  const cnt = (k) => items.filter((i) => i.kategori === k).length;
  const diff = [["ucretli_izin_gun", "ucretli_izin", "Ücretli / Yıllık"], ["ucretsiz_izin_gun", "ucretsiz_izin", "Ücretsiz"], ["raporlu_gun", "raporlu", "Rapor"]]
    .map(([f, k, l]) => [l, (row[f] || 0) - cnt(k)]).filter(([, d]) => d > 0.01);
  if (!diff.length) return null;
  return (
    <div className="text-[11px] text-slate-500 mt-1.5" data-testid="leave-days-manual">
      Takvimde günü işaretlenmeden bordroya elle girilen: {diff.map(([l, d]) => `${l} ${n1(d)} gün`).join(" · ")}
    </div>
  );
};

export function LeaveDaysList({ row, yil, ay, onChanged }) {
  const [items, setItems] = useState(null);
  const [dlg, setDlg] = useState(null);
  const [tick, setTick] = useState(0);
  useEffect(() => {
    api.get(`/puantaj/leave-days?personnel_id=${row.personnel_id}&yil=${yil}&ay=${ay}`)
      .then((r) => setItems(r.data.items)).catch(() => setItems([]));
  }, [row.personnel_id, yil, ay, tick]);
  if (items === null) return <div className="text-xs text-slate-400">Yükleniyor...</div>;
  return (
    <div data-testid={`leave-days-${row.personnel_id}`}>
      {items.length === 0 && <div className="text-xs text-slate-400">Takvimde işaretli izin günü yok.</div>}
      <ul className="grid sm:grid-cols-2 lg:grid-cols-3 gap-1.5">
        {items.map((i) => (
          <li key={i.tarih} className="flex items-center gap-2 text-xs bg-white border border-slate-200 rounded-md px-2 py-1" data-testid={`leave-day-${i.tarih}`}>
            <span className="font-mono-tab font-semibold text-slate-800">{fmtDate(i.tarih)}</span>
            <span className="text-slate-500">{GUN[new Date(`${i.tarih}T00:00:00`).getDay()]}</span>
            <span className={`ml-auto px-1.5 py-0.5 rounded text-[10px] font-bold ${TONE[i.kategori]}`}>{i.tur}{i.yarim ? " · yarım gün" : ""}</span>
            <span className="text-[10px] text-slate-400">{i.kaynak}</span>
            {i.leave_id && (
              <button type="button" onClick={() => setDlg(i.leave_id)} data-testid={`leave-day-manage-${i.tarih}`}
                title="İzin/rapor kaydını düzenle veya sil" className="w-5 h-5 grid place-items-center text-indigo-600 hover:bg-indigo-50 rounded">
                <Edit size={11} />
              </button>
            )}
          </li>
        ))}
      </ul>
      <ManualNote row={row} items={items} />
      {dlg && <LeaveRecordDialog leaveId={dlg} personnelId={row.personnel_id} onClose={() => setDlg(null)} onChanged={() => { setTick((t) => t + 1); onChanged?.(); }} />}
    </div>
  );
}
